module.exports = __webpack_public_path__ + "img/screen-10.6a4696e2.png";